import jQuery from 'jquery';

jQuery(($) => {
  //--------------------------------------------------
  // Dynamically add anchor to sort index

  $('.is-active').each(function (i) {
    const id = $(this).attr('id');
    // this is just to display the consultants that are displayed
    if (i === 0) {
      $(`#sort_index_${id}`).html(`<a href="#${id}" class="active">${id}</a>`);
    } else {
      $(`#sort_index_${id}`).html(`<a href="#${id}">${id}</a>`);
    }
  });

  //--------------------------------------------------
  // Scroll to target section

  $('.index a').on('click', function (e) {
    e.preventDefault();
    const target = $(this).attr('href');
    $(this).parent().find('a').removeClass('active');
    $(this).addClass('active');

    document.querySelector('html, body').scrollTo({
      top: document.querySelector(target).offsetTop - 60,
      behavior: 'smooth',
    });

    setTimeout(() => {
      document.querySelectorAll('.target').forEach((el) => {
        el.removeAttribute('tabindex');
      });

      const targetElement = document.querySelector(target);
      targetElement.focus();

      if (document.activeElement === targetElement) {
        // Checking if the target was focused
        return false;
      }
      targetElement.setAttribute('tabindex', '-1'); // Adding tabindex for elements not focusable
      targetElement.focus(); // Set focus again
    }, 1000);
  });

  //--------------------------------------------------
  // Highlight Index item currently in view

  $(window).on('scroll', () => {
    $('.target').each(function () {
      if ($(window).scrollTop() >= $(this).offset().top - 80) {
        const id = $(this).attr('id');
        $('.index a').removeClass('active');
        $(`.index a[href="#${id}"]`).addClass('active');
      }
    });
  });
});
